<qaroni-query-param-select-object-filter
  [options]="departments$ | async"
  [label]="departmentFilterLabel()"
  textKey="name"
  valueKey="departmentId"
  [queryParamName]="queryParamName()"
  [multiple]="multiple()"
  (queryParamsChange)="onQueryParamsChange($event)" />
